import { Button } from 'primereact/button';
import globalConfigStore from '../../../../../../stores/global-config-store';
import React, { useEffect, useState } from 'react';
import { AvailabilityResponse } from '../../../../../../api/types/calender/avalability-slots/availability-response';
import { getAvailabilitySlotsOperations } from './operations/get-availability-slots-operations';
import { Column, ColumnBodyOptions } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { AvailabilitySlot } from '../../../../../../api/types/calender/avalability-slots/availability-slot';
import { SelectedSlotsState } from './types/selected-slots';

interface TimeSlotContainerDataModel {
  branchId: number;
  startDate: Date | null;
  startTime: Date | null;
  endTime: Date | null;
  iterationNumber: number;
  selectedSlots: SelectedSlotsState;
  handleSlotSelect: (
    lectureNumber: number,
    slot: AvailabilitySlot | null,
  ) => any;
  shouldInitiateSearchSlot: boolean;
  editTimeSlot: {
    start: Date;
    end: Date;
    classId: number;
  };
}
export const TimeSlotContainer: React.FC<TimeSlotContainerDataModel> = ({
  branchId,
  startTime,
  startDate,
  endTime,
  iterationNumber,
  selectedSlots,
  handleSlotSelect,
  shouldInitiateSearchSlot,
  editTimeSlot,
}) => {
  const [availabilitySlots, setAvailabilitySlots] = useState<
    AvailabilityResponse[]
  >([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (shouldInitiateSearchSlot) {
      handleSlotContainer();
    }
  }, [shouldInitiateSearchSlot]);

  const handleSlotContainer = async () => {
    const branchId2 =
      branchId || globalConfigStore.rootFilter.currentBranches.id;

    await getAvailabilitySlotsOperations(
      branchId2,
      startDate,
      startTime,
      endTime,
      iterationNumber,
      setIsLoading,
      setAvailabilitySlots,
      handleSlotSelect,
      editTimeSlot,
    );
  };

  return (
    <div>
      {/*<label>סדרת הרצאות</label>
      <Tag value={'Asd'} severity={'danger'} style={{ borderRadius: '50px' }} />

      <div>{availabilitySlots.length}</div>*/}

      <Button
        style={{ height: '36px' }}
        onClick={handleSlotContainer}
        severity="info"
        label={'לחץ בדיקת זמינות החדרים'}
        loading={isLoading}
      />

      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={availabilitySlots?.[0]?.slots ?? []}
        scrollable
        onSelectionChange={(e) => {
          //setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right', height: '40px' }}
          field="courseName"
          header={'הרצאות'}
          headerStyle={{
            height: '45px',
            maxHeight: '45px',
            padding: '0',
            paddingRight: '16.5px',
          }}
          body={(data: AvailabilitySlot, options: ColumnBodyOptions) => (
            <div>הרצאה {options.rowIndex + 1}</div>
          )}
        />
        {availabilitySlots.map((classItemSlots) => (
          <Column
            style={{ textAlign: 'right', height: '40px' }}
            field="courseName"
            header={classItemSlots.className}
            headerStyle={{
              height: '45px',
              maxHeight: '45px',
              padding: '0',
              paddingRight: '16.5px',
            }}
            body={(data: AvailabilitySlot, options: ColumnBodyOptions) => (
              <div>
                <div>
                  {classItemSlots.slots[options.rowIndex].isAvailable ? (
                    <Button
                      style={{ height: '30px' }}
                      severity={
                        selectedSlots?.[options.rowIndex]?.some(
                          (item) => item.classId === classItemSlots.classId,
                        )
                          ? 'success'
                          : 'primary'
                      }
                      value={'asd'}
                      outlined={
                        !selectedSlots?.[options.rowIndex]?.some(
                          (item) => item.classId === classItemSlots.classId,
                        )
                      }
                      label="פנוי"
                      onClick={() =>
                        handleSlotSelect(options.rowIndex, {
                          classId: classItemSlots.classId,
                          startTime:
                            classItemSlots.slots[options.rowIndex].startTime,
                          endTime:
                            classItemSlots.slots[options.rowIndex].endTime,
                          isAvailable:
                            classItemSlots.slots[options.rowIndex].isAvailable,
                        })
                      }
                    />
                  ) : (
                    <Button
                      style={{ height: '30px' }}
                      severity={'secondary'}
                      value={'asd'}
                      label="תפוס"
                      disabled={true}
                    />
                  )}
                </div>
              </div>
            )}
          />
        ))}
      </DataTable>
    </div>
  );
};
